module.exports = __webpack_public_path__ + "media/src/images/icon__magazinHappy2-e4fb9d2dc9c12b15f8c1eaf04929ec8c.svg";